import ContactLine from "../Parts/ContactLine";
import ContactMail from "../Parts/ContactMail";
import ContactLineForBusinnessUrl from "../Parts/ContactForBusinness";
import ContactMailForBusinness from "../Parts/ContactMailForBussiness";
import Seo from "../Components/Seo";

import { CgDanger } from "react-icons/cg";

export default function ContactForm() {
  return (
    <div>
      <Seo
        pageTitle="お問い合わせ"
        description="防犯カメラ・監視カメラの選定や設置に関するご相談はこちら。商品の比較から設置の相談まで、お気軽にお問い合わせください。"
        url="https://camarago.com/contact"
      />
      <div className="text-white py-12 w-11/12 md:w-1/2 m-auto leading-loose">
        <h1 className="text-3xl font-bold">お問い合わせフォーム</h1>
        <p className="py-3">
          商品の比較から設置の相談など、お気軽にお問い合わせください。専門スタッフが丁寧に対応いたします。
        </p>
        <small>
          <CgDanger className="inline text-lg" /> 返信には1営業日いただく場合がございます。
        </small>
      </div>

      <div className="w-11/12 md:w-1/2 m-auto">
        <h2 className="text-2xl text-white font-bold mt-10 mb-5 ">
          カメラの設置に関するご相談の方
        </h2>
      </div>
      <ContactLine />
      <ContactMail />

      <div className="w-11/12 md:w-1/2 m-auto">
        <h2 className="text-2xl text-white font-bold mt-10 mb-5 ">
          カメラ情報をサイトに掲載希望の方
        </h2>
      </div>

      <ContactLineForBusinnessUrl />
      <ContactMailForBusinness />
    </div>
  );
}
